import { Box, Typography } from '@mui/material';
import { _ } from '/@/locale';
import HelpCenterIcon from '/@/styles/assets/catalog/expertobayer-action-2.svg';

export const HelpCenterHomeHero = () => {
    return (
        <>
            <Box component='img' src={HelpCenterIcon} alt='App logo' />

            <Typography variant='h4' color='primary'>
                {_('Centro de ayuda')}
            </Typography>
        </>
    );
};
